import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
const Certification: React.FC = () => {
    const { t } = useLang('theProduct.Certification');
    const [rules, setRules] = useState<any>([]);
    const [isOpen, setIsOpen] = useState(false);
    const ruleList = [
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747033969291/472386420926046208%201.png',
            title: t('C_list_title1'),
            desc: t('C_list_desc1'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747038740227/cert3.png',
            title: t('C_list_title2'),
            desc: t('C_list_desc2'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747038740227/cert3.png',
            title: t('C_list_title3'),
            desc: t('C_list_desc3'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747038578043/cert2.png',
            title: t('C_list_title4'),
            desc: t('C_list_desc4'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747039059858/cert4.png',
            title: t('C_list_title5'),
            desc: t('C_list_desc5'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747042471615/cert6.png',
            title: t('C_list_title6'),
            desc: t('C_list_desc6'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1747039059858/cert4.png',
            title: t('C_list_title9'),
            desc: t('C_list_desc9'),
        },
        {
            url: 'https://websiteoss.ecoflow.com/upload/image/1746238143963/img_v3_02lj.jpg',
            title: t('C_list_title10'),
            desc: t('C_list_desc10'),
        },
    ];

    const handleViewAll = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            setRules(ruleList);
        } else {
            setRules(ruleList.slice(0, 4));
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setRules(ruleList.slice(0, 4));
            } else {
                setRules(ruleList);
            }
        }
    }, []);

    return (
        <section className={styles.Certification}>
            <div className="title1">{t('C_title')}</div>
            <div className="subtitle1">{t('C_desc')}</div>
            <div className="content">
                {rules.map((item: any, index: number) => (
                    <div className="cert-item" key={index}>
                        <div className="cert-icon">
                            <EfIcon pc={item.url} />
                        </div>
                        <div className="cert-title">{item.title}</div>
                        <div className="cert-desc">{item.desc}</div>
                    </div>
                ))}
            </div>
            <div className="view-m">
                <div className="view-all" onClick={handleViewAll}>
                    {!isOpen && <span>{t('C_view_all')}</span>}
                    {isOpen && <span>{t('C_view_all_2')}</span>}
                    {isOpen ? (
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                            <path d="M5.5 12.5L10.5 7.5L15.5 12.5" stroke="#3F68E0" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                            <path d="M15.5 7.76172L10.5 12.7617L5.5 7.76172" stroke="#3F68E0" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                </div>
            </div>
        </section>
    );
};

export default Certification;
